import { IConfirmableInjectedAction } from '../../../../interfaces';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { get, map, without } from 'lodash';

export class InjectedUserActivationRetrigger implements IConfirmableInjectedAction {
  performActionAfterConfirm = (bindObj, action) => {
    const isCredentialUser = get(action, 'rowData.credentialUser', false);

    if (!isCredentialUser) {
      bindObj.worklist.notificationMessageService.info('Selected Practitioner is not a credential user');

      return;
    }

    // Getting Telecom Array entry for a selected practitioner
    const telecomArray = get(action, 'rowData.telecom', []);
    // Getting registered email address from the telecom array
    let emailAddress = map(telecomArray, function(entities) {
       return entities.system === 'email' ? entities.value : '';
    });
    // Filtering Array to remove junk values
    emailAddress = without(emailAddress, undefined, '', null);

    if (emailAddress.length < 1) {
      bindObj.worklist.notificationMessageService.info('Practitioner is not associated with email address');
      return;
    }

    bindObj.worklist.reTriggerUserActivationService.retriggerRequest(emailAddress)
      .subscribe(
        (data) => {
          if (data.issue && data.issue[0].details) {
            bindObj.worklist.notificationMessageService.info(data.issue[0].details.text);
          }
        },
        catchError((err) => {
          console.error('Failed to Retrigger User Activation Service : performActionAfterConfirm() : Error : ', err.message);
          return of(err);
        })
      );

    bindObj.worklist.reTriggerUserActivationService.retriggerRequest(emailAddress)
      .subscribe(
        (data) => {
          if (data.issue && data.issue[0].details) {
            bindObj.worklist.notificationMessageService.info(data.issue[0].details.text);
          }
        },
        catchError((err) => {
          console.error('Failed to Retrigger User Activation Service : performActionAfterConfirm() : Error : ', err.message);
          return of(err);
        })
    );
  }
}
